import React from 'react'

import { twMerge } from 'tailwind-merge'

import Spinner from '@/components/common/Spinner'

interface DataLoadingProps {
  className?: string
}

export const DataLoading: React.FC<DataLoadingProps> = ({ className }) => {
  return (
    <div
      className={twMerge(
        'flex flex-col items-center justify-center w-full h-full',
        className,
      )}
    >
      <Spinner className="w-5 h-5" />
    </div>
  )
}
